<template>
    <div class="app-showcase-process-step__two section-space--pt_60">
        <div class="row align-items-center">
            <div class="col-lg-6 order-2 order-lg-1">
                <div class="app-showcase-process-step__content text-div section-space--mt_40">
                    <div class="app-showcase__inner">
                        <div class="sub__title mb-20">
                            <h6 class="font-weight--blod  wow move-up">{{ subtitle }}</h6>
                        </div>
                        <h2 class="font-weight--light wow move-up sub-title">Dreaming of a<br> flight to London <br>or a beach <br>wedding in Bali,<br>just <span class="yellow-sub-title">set a goal <br> and save.</span></h2>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 order-1 order-lg-2">
                <div class="app-showcase-process-step__media text-center wow move-up">
                    <img :src="img" class="img-fluid" alt="thumbnail">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'ShowcaseAdvancedFeatures',
        data(){
            return {
                img: require("../assets/img/iphone4.png"),
                subtitle: "Goal based savings!",
            }
        }
    };
</script>

<style>
    .text-div{
        padding-left:20%
    }
    .sub-title{
        color:#3D3D3D;
        font-family: Nunito Sans;
        font-style: normal;
        font-weight: 900;
    }
    .yellow-sub-title{
        color:#FFBE2E !important;
    }
</style>